import React from 'react';

// A small, reusable component for displaying a list of words
const WordList = ({ title, words }) => {
  if (!words || words.length === 0) {
    return null; // Don't render anything if the list is empty
  }
  return (
    <div className="data-column">
      <h3>{title}</h3>
      <ul>
        {words.slice(0, 15).map((word, index) => ( // Show up to 15 words
          <li key={index}>{word}</li>
        ))}
      </ul>
    </div>
  );
};

// A component for displaying definitions
const Definitions = ({ definitions }) => {
  if (!definitions || definitions.length === 0) {
    return null;
  }
  return (
    <div className="data-column definitions">
      <h3>Definitions</h3>
      {definitions.slice(0, 3).map((meaning, index) => ( // Show first 3 meanings
        <div key={index} className="definition-block">
          <span className="part-of-speech">{meaning.partOfSpeech}</span>
          <p>{meaning.definitions[0]?.definition}</p>
        </div>
      ))}
    </div>
  );
};


// The main component that brings everything together
const StructuredData = ({ data }) => {
  if (!data) {
    return null; // Don't render if there's no data
  }

  return (
    <div className="structured-data-container">
      <WordList title="Synonyms" words={data.synonyms} />
      <WordList title="Antonyms" words={data.antonyms} />
      <WordList title="Sounds Like" words={data.soundsLike} />
      <WordList title="Related Words" words={data.related} />
      <Definitions definitions={data.definitions} />
    </div>
  );
};

export default StructuredData;